// Components
import { Flex, Text } from 'yard-utilities/components'

// Redux
import { useAppSelector } from '@redux/hooks'

// Helpers
import { displayExchangedPrice } from '@helpers/exchangeRate'

interface ReviewProps {
  name: React.ReactNode
  quote: string
  message: string
  price?: number
  messageEnd?: string
  memberSince: number
}

const TextReviewCard = ({
  name,
  quote,
  message,
  price,
  messageEnd,
  memberSince
}: ReviewProps) => {
  const { exchangeRate, currency, currencyLoaded } = useAppSelector(
    (state) => state.visitor
  )

  return (
    <Flex flexDirection="column" center style={{ marginInline: '-1rem' }}>
      <Text tagName="h3" variant="title-5" align="center" spacing={{ sm: 16 }}>
        {quote}
      </Text>
      <Text
        tagName="p"
        variant="body-1"
        align="center"
        textColor="grey-2"
        spacing={{ sm: 8 }}
      >
        {message}
        {price
          ? displayExchangedPrice({
              value: 500,
              exchangeRate,
              currency,
              loaded: currencyLoaded
            })
          : ''}
        {messageEnd ? messageEnd : ''}
      </Text>
      <Text tagName="p" variant="body-1" align="center" spacing={{ sm: 4 }}>
        {name}
      </Text>
      <Text tagName="p" variant="body-3" align="center" textColor="grey-2">
        Miembro desde {memberSince}
      </Text>
    </Flex>
  )
}

export default TextReviewCard
